import axios, { AxiosError } from 'axios';

import { getStorefrontUrl } from '~/helpers/getStorefrontUrl';
import storage from '~/storage';

import { getToken } from '../helpers/getToken';

const requestInstance = axios.create({
  baseURL: getStorefrontUrl('/api/v1').toString(),
});

requestInstance.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (!token) {
      return Promise.reject(new Error('Missing token'));
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => Promise.reject(error),
);

requestInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if ((error as AxiosError).response?.status === 401) {
      try {
        window.sessionStorage.removeItem('token');
      } catch {
        storage().delete('token');
      }
    }
    return Promise.reject(error);
  },
);

export default requestInstance;
